<template>
    <BaseBoxSection :title="__('information_about_the_contract_order')" :helpName="helpName">
        <div class="col-3">
            <label>{{ __('contract_source') }}</label>
            <input :value="data.source" class="form-control" disabled type="text">


        </div>
        <div class="col-3">
            <label>{{ __('contract-order-name') }}</label>
            <input :value="data.name" class="form-control" disabled type="text">

        </div>

        <div class="col-3">
            <label>{{ __('contract_order_type') }}</label>
            <input :value="data.typeName" class="form-control" disabled type="text">
        </div>

        <div class="col-3">
            <label>{{ __('type_of_contract_order') }}</label>
            <select2 :settings="{ width: '100%' }" :options="typesOfContract" :value="data.typeOfContract" disabled/>
        </div>

        <div class="col-3">
            <label>{{ __('contract_number') }}</label>
            <input :value="data.number" class="form-control" disabled type="text">
            <p class="m-t-xs mb-0">
                <label>
                    <input
                        :checked="data.detailed"
                        disabled
                        type="checkbox"
                    >
                    {{ __('contract-detailed') }}
                </label>
            </p>
        </div>

        <div class="col-3">
            <label>{{ __('currency') }}</label>
            <input :value="data.currencyName" class="form-control" disabled type="text">
        </div>

        <div class="col-3">
            <label>{{ __('contract-order-date') }}</label>
            <datepicker
                :initWithoutEmitEvent="true"
                :value="data.date"
                disabled
            />
        </div>

        <div class="col-3">
            <label>{{ __('terms_of_delivery') }}</label>
            <input :value="data.terms_of_delivery" class="form-control" disabled type="text">
        </div>


    </BaseBoxSection>
</template>

<script>
import BaseBoxSection from "../BaseBoxSection";

export default {
    name: "BasicInformationDisplayBox",
    components: {BaseBoxSection},
    props: {
        data: {
            type: Object,
            required: true
        },
        typesOfContract: {
            type: Array,
            default: [],
        },
        helpName: {
            type: String,
            required: true,
        },
    },
};
</script>
